import { City, InputBoX, Summary, TableHead, MenuOption } from "./Default"
import LogisticsAxios from '../../service/logistics'
import globalData from '../globalData'

/**物流参考报价 */
class LogisticsQuotation{
  constructor(){
    /**分类 */
    this.logisticsSort = ''
    /**收货国家 */
    this._receivingAddress = ''
    /**送仓地址 */
    this.deliveryAddress = ''
    /**送仓地址选项 */
    this.deliveryAddressArray = []
    /**寄件地址 */
    this.shippingAddress = ''
    this.shippingAddressId = ''
    /**长 */
    this.long = ''
    /**宽 */
    this.width = ''
    /**高 */
    this.height = ''
    /**数量 */
    this.num = ''
    /**重量 */
    this.weight = ''
    /**产品状况 */
    this.logisticsStatus = []
    /**是否独立报关 */
    this.logisticsIsDeclare = ''
    /**入口清关及缴税 */
    this._sqbs = ''
    /**采购数量 */
    this.stockNum = 0
    /**采购单价 */
    this.stockPrice = 0
    /**物流API对应产品状态 */
    this.productStatusByLogistics = globalData.productStatusByLogistics
  }
  get receivingAddress(){ return this._receivingAddress }
  get sqbs(){ return globalData.sqbsInputOptions[this._sqbs] }
  set receivingAddress(newVal){
    this._receivingAddress = newVal
    /**获取 Matrix 仓库代码 */
    LogisticsAxios.getFbaId({ countrySite: newVal }).then(res => {
      if(res.data.code === 1){
        this.deliveryAddressArray = res.data.info.map(e => new LogisticsQuotationAddressMenuOption(e.name, e.id, { show: true }))
      }
    })
  }
  set sqbs(newVal){
    this._sqbs = newVal
  }
  /**清空数据 */
  clearData(){
    // this.logisticsSort = ''
    // this.receivingAddress = ''
    this.deliveryAddress = ''
    this.shippingAddress = ''
    this.shippingAddressId = ''
    this.long = ''
    this.width = ''
    this.height = ''
    this.num = ''
    this.weight = ''
    this.logisticsStatus = []
    // this.logisticsIsDeclare = ''
  }
  /**计算运费请求体 */
  get getCalculateShipPriceBody(){
    let obj = {
      products: [{
        productModel: '',
        boxWeight: this.weight,
        boxLength: this.long,
        boxWidth: this.width,
        boxHeight: this.height,
        productInsure: this.productValue,
        boxNumber: this.boxNum
      }],
      countrySite: this.receivingAddress,
      fbaId: this.deliveryAddress,
      productStatus: this.judgeProductStatusByLogistics(),
      address: this.shippingAddress
    }
    return obj
  }
  /**总箱数 */
  get boxNum(){
    return Math.ceil(Number(this.stockNum) / Number(this.num? this.num: 1))
  }
  /**产品价值 */
  get productValue(){
    return Number(this.stockNum) * Number(this.stockPrice)
  }
  /**判断当前产品状态对应物流API哪个状态 */
  judgeProductStatusByLogistics(){
    let obj = {
      '03' : 4,
      '04' : 6,
      '05' : 8,
      '13' : 1,
      '14' : 3,
      '15' : 8,
      '23' : 2,
      '24' : 5,
      '25' : 8
    }
    let statusIndexArray = this.logisticsStatus.map(e => globalData.logisticsStatusInputOptions.indexOf(e))
    console.log(statusIndexArray);
    let key = statusIndexArray.join('').slice(0, 2)
    return obj[key]
  }
  /**判断是否可以发送计算运费请求 */
  judgeSendCalculateAxios(){
    let arr = [
      'weight',
      'long',
      'width',
      'height',
      'productValue',
      'boxNum',
      'receivingAddress',
      'deliveryAddress',
      'shippingAddress',
      'logisticsStatus'
    ]
    return arr.every(key => {
      return this[key] || (this[key] == 0  && this[key] !== '')
    })
  }
}

/**物流方式 */
class LogisticsMethod{
  constructor(carrier, freightDetails, method, transitDays, startShipment,
    firstTransportationDays, customsClearanceDays, lastTransportationDays,
    sqbs, freight) {
    /**承运商 */
    this.carrier = carrier
    /**货运详情 */
    this.freightDetails = freightDetails
    /**物流方式 */
    this.method = method
    /**中转天数 */
    this.transitDays = transitDays
    /**国际物流启运期等待天数 */
    this.startShipment = startShipment
    /**头程运输天数 */
    this.firstTransportationDays = firstTransportationDays
    /**清关天数 */
    this.customsClearanceDays = customsClearanceDays
    /**尾程运输天数 */
    this.lastTransportationDays = lastTransportationDays
    /**清关及入口税 */
    this.sqbs = sqbs
    /**总运费 */
    this.freight = freight
  }
  /**总运输天数 */
  get totalDays(){
    let dayArray = ['transitDays', 'startShipment', 'firstTransportationDays', 'customsClearanceDays', 'lastTransportationDays']
    let tmpArr = []
    let min, max
    min = max = 0
    dayArray.map(str => {
      tmpArr = this[str].split('~')
      min = min + Number(tmpArr[0])
      max = max + Number(tmpArr[1])
    })
    return min + '~' + max
  }
}

/**物流参考报价地址菜单选项 */
class LogisticsQuotationAddressMenuOption extends MenuOption{
  constructor(name, id, obj = { show: false }) {
    super(name, id)
    this.show = obj.show
  }
}

/**物流报价输入框类 */
class LogisticsQuotationInputBox extends InputBoX{
  constructor(type, name, data, obj = { decimal: 0, pla: '', html: false }){
    super(type, name, data, obj)
  }
}

/**物流参考报价表头类 */
class LogisticsTableHead extends TableHead{
  constructor(name, prop, width, html) {
    super(name, prop, width)
    this.html = html? this.prop + 'Html': ''
  }
}

/**物流参考报价汇总类 */
class LogisticsSummary extends Summary{
  constructor(name, data, obj) {
    super(name, data, obj)
  }
}

/**物流报价输入模块创建类 */
class LogisticsQuotationInputNewModule{
  /**亚马逊FBA物流报价输入模块 */
  static NEWINPUT(){
    let arr = [
      new LogisticsQuotationInputBox('select', '独立报关退税', 'logisticsIsDeclare', { isDisable: true }),
      new LogisticsQuotationInputBox('select', '货件分类', 'logisticsSort', { isDisable: true }),
      new LogisticsQuotationInputBox('select', '收件国家/地区', 'receivingAddress', { isDisable: true }),
      new LogisticsQuotationInputBox('select', '送仓地址', 'deliveryAddress'),
      new LogisticsQuotationInputBox('select', '寄件地址', 'shippingAddress'),
      new LogisticsQuotationInputBox('select', '外箱尺寸(cm)', 'size'),
      new LogisticsQuotationInputBox('select', '装箱数量/重量', 'box'),
      new LogisticsQuotationInputBox('select', '产品状况', 'logisticsStatus'),
    ]
    return arr
  }
  /**尺寸输入模块 */
  static NEWSIZE(){
    let arr = [
      new LogisticsQuotationInputBox('input', '长', 'long', { pla: '长' }),
      new LogisticsQuotationInputBox('input', '宽', 'width', { pla: '宽' }),
      new LogisticsQuotationInputBox('input', '高', 'height', { pla: '高' }),
    ]
    return arr
  }
  /**装箱数量输入模块 */
  static NEWBOX(){
    let arr = [
      new LogisticsQuotationInputBox('input', '装箱数', 'num', { pla: '装箱数' }),
      new LogisticsQuotationInputBox('input', '重量', 'weight', { pla: '重量' }),
    ]
    return arr
  }
  /**地址菜单 */
  static NEWADDRESSMENU(){
    let arr = [
      new LogisticsQuotationAddressMenuOption('常用城市', 'common', { show: true }),
      new LogisticsQuotationAddressMenuOption('省', 'province', { show: true }),
      new LogisticsQuotationAddressMenuOption('市', 'city'),
      new LogisticsQuotationAddressMenuOption('区', 'county')
    ]
    return arr
  }
  /**常用城市 */
  static NEWCOMMONADDRESS(){
    let arr = [
      new City('上海市', '27318', { provinceName: '上海', provinceId: 27317 }),
      new City('东莞市', '4439', { provinceName: '广东省', provinceId: 4390 }),
      new City('中山市', '5800', { provinceName: '广东省', provinceId: 4390 }),
      new City('佛山市', '4466', { provinceName: '广东省', provinceId: 4390 }),
      new City('北京市', '1639', { provinceName: '北京', provinceId: 1638 }),
      new City('南京市', '18510', { provinceName: '江苏省', provinceId: 18273 }),
      new City('厦门市', '2913', { provinceName: '福建省', provinceId: 1962 }),
      new City('台州市', '34807', { provinceName: '浙江省', provinceId: 33998 }),
      new City('合肥市', '725', { provinceName: '安徽省', provinceId: 5 }),
      new City('嘉兴市', '34200', { provinceName: '浙江省', provinceId: 33998 }),
      new City('天津市', '30861', { provinceName: '天津', provinceId: 30860 }),
      new City('宁波市', '34510', { provinceName: '浙江省', provinceId: 33998 }),
      new City('常州市', '18274', { provinceName: '江苏省', provinceId: 18273 }),
      new City('广州市', '4504', { provinceName: '广东省', provinceId: 4390 }),
      new City('惠州市', '4757', { provinceName: '广东省', provinceId: 4390 }),
      new City('成都市', '27852', { provinceName: '四川省', provinceId: 27516 }),
      new City('抚顺市', '19389', { provinceName: '江西省', provinceId: 19388 }),
      new City('无锡市', '18864', { provinceName: '江苏省', provinceId: 18273 }),
      new City('杭州市', '33999', { provinceName: '浙江省', provinceId: 33998 }),
      new City('武汉市', '14880', { provinceName: '湖北省', provinceId: 14226 }),
      new City('泉州市', '2614', { provinceName: '福建省', provinceId: 1962 }),
      new City('济南市', '23819', { provinceName: '山东省', provinceId: 23469 }),
      new City('深圳市', '5462', { provinceName: '广东省', provinceId: 4390 }),
      new City('温州市', '34898', { provinceName: '浙江省', provinceId: 33998 }),
      new City('福州市', '1963', { provinceName: '福建省', provinceId: 1962 }),
      new City('绍兴市', '34712', { provinceName: '浙江省', provinceId: 33998 }),
      new City('苏州市', '18695', { provinceName: '江苏省', provinceId: 18273 }),
      new City('莆田市', '2558', { provinceName: '福建省', provinceId: 1962 }),
      new City('郑州市', '12358', { provinceName: '河南省', provinceId: 10764 }),
      new City('重庆市', '35156', { provinceName: '重庆', provinceId: 35155 }),
      new City('金华市', '34253', { provinceName: '浙江省', provinceId: 33998 }),
      new City('青岛市', '24317', { provinceName: '山东省', provinceId: 23469 }),
    ]
    return arr
  }
  /**表头数据 */
  static NEWTABLEHEAD(){
    let arr = [
      new LogisticsTableHead('选择', 'radio', 40),
      new LogisticsTableHead('承运商', 'carrier', 60),
      new LogisticsTableHead('收件方式', 'freightDetails', 80),
      new LogisticsTableHead('头程及尾程<br>物流方式', 'method', 120),
      new LogisticsTableHead('入口清关<br>及缴税', 'sqbs', 90),
      new LogisticsTableHead('预计收件送至<br>中转仓库天数', 'transitDays', 100),
      new LogisticsTableHead('国际物流启运<br>等待天数', 'startShipment', 100),
      new LogisticsTableHead('预计头程<br>运输天数', 'firstTransportationDays', 70),
      new LogisticsTableHead('预计清关<br>天数', 'customsClearanceDays', 70),
      new LogisticsTableHead('预计尾程<br>运输天数', 'lastTransportationDays', 70),
      new LogisticsTableHead('全程<br>天数', 'totalDays', 50),
      new LogisticsTableHead('全程运费<br>(￥)', 'freight', 70),
    ]
    return arr
  }
  /**表格测试数据 */
  static NEWTABLETESTDATA(){
    let arr = [
      // new LogisticsMethod('iMaxShip', '上门收件', '海运+快递派送', '1-2', '1-3', '15-25', '1-3', '1-5', '双清包税', '数据导入'),
      // new LogisticsMethod('iMaxShip', '上门收件', '海运+快递派送', '1-2', '1-3', '15-25', '1-3', '1-5', '双清包税', '数据导入'),
      // new LogisticsMethod('iMaxShip', '上门收件', '空运+快递派送', '1-2', '1-3', '6-9', '1-3', '1-5', '双清包税', '数据导入'),
      // new LogisticsMethod('iMaxShip', '上门收件', '海运+快递派送', '1-2', '1-3', '6-9', '1-3', '1-5', '双清包税', '数据导入'),
      // new LogisticsMethod('iMaxShip', '上门收件', '铁路运+卡车派送', '1-2', '1-3', '3-5', '1-3', '1-5', '双清包税', '数据导入'),
      // new LogisticsMethod('iMaxShip', '上门收件', '海运+快递派送', '1-2', '1-3', '3-5', '1-3', '1-5', '双清包税', '数据导入'),
    ]
    return arr
  }
  /**表格汇总数据 */
  static NEWTABLESUMMARY(){
    let arr = [
      new LogisticsSummary('总重量', 200, { unit: 'KG' }),
      new LogisticsSummary('总体积', 1.58, { unit: 'M³' }),
      new LogisticsSummary('总箱数', 20, { unit: '箱' }),
      new LogisticsSummary('总申报价值', 1245, { preUnit: '¥' }),
    ]
    return arr
  }
}

export{
  LogisticsQuotation, LogisticsQuotationInputNewModule,
  LogisticsMethod, LogisticsQuotationAddressMenuOption
}
